import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {Game} from "../Game";
import {gsap} from "gsap";
import {GameFeatureMode} from "../enums/Enum";
import {Sound} from "../sound/Sound";

export class SFSIntroRunner implements SimplePresentation {
    private static closedCallback(controller: SimplePresentationRunnerController): void {
        Game.keypadPlugin.setZeroBetSpinCounter(Game.model.data.freespinsLeft);
        controller.finish();
    }

    shouldRun(): boolean {
        return Game.model.gameData.mode === GameFeatureMode.NORMAL && Game.model.gameData.nextMode === GameFeatureMode.FREESPIN_SUPER;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        controller.setSkipCallback(undefined);
        tl.add(() => {
            Game.soundPlayer.playSound(Sound.SFS_INTRO_LOOP_START);
            Game.soundPlayer.switchMusic("SFS_INTRO");
        });
        tl.add(Game.sfsIntroView.show(() => {
            SFSIntroRunner.closedCallback(controller);
        }));
    }


}